// Overview API
import Api from './api';

// Custom HTML Elements
import ListItem from './elements/listItem';
import Pager from './elements/pager';

// Browser history API
// import {
//     createBrowserHistory
// } from 'history'; // TODO: Implement if needed/wanted

// Session cookies
// import Cookies from 'js-cookie'; // TODO: Implement if needed/wanted

// Google Maps, Places API, markerClusterer, map styling
import MarkerClusterer from '@googlemaps/markerclustererplus';
// import mapStyling from './mapStyling';

export default class volunteerVacanciesOverviewController {
    constructor() {
        // DOM (appended at other sections)
        this.dom = {
            container: document.querySelector('section.volunteerVacanciesOverview'),
            html: document.querySelector('html')
        };

        // Paging
        this.currentPage = 1;
        this.totalPages = 1;
        this.itemsPerPage = 10;
        this.dom.pager = null;

        // Items
        this.items = [];

        // API
        this.api = new Api();

        // Filters
        this.filterObject = null;
        this.selectedFilters = [];

        // Maps
        this.apiKey = null; // Maps API key. Needs to have Places API enabled!
        this.map = null;
        this.markers = [];
        this.infoBox = null;
        this.markerClusterer = null;
        this.dom.mapContainer = this.dom.container.querySelector('.mapContainer');

        // Start application
        this.init();
    }


    /**************
     * Initialization
     **************/

    /**
     * Application starts from here
     */
    init() {
        const fetchData = this.fetch();
        const loadMaps = app.loadGoogleMapsApi(this.dom.container.dataset.key); // Start loading Maps api in advance

        loadMaps.then(() => {
            this.createMap();
        });

        Promise.all([fetchData, loadMaps]).then(() => {
            this.insertItemsIntoView();
            this.initPager();
            this.initAutocomplete();
        });

        // Event listeners
        
        this.dom.container.querySelectorAll('.tabsNavigation li').forEach(li => {
            li.addEventListener('click', () => this.changeView(li));
        });

        let typeDropdown = this.dom.container.querySelector('select[name="type"]');
        let durationDropdown = this.dom.container.querySelector('select[name="duration"]');
        if (typeDropdown) {
            typeDropdown.addEventListener('change', () => {
                this.fetch().then(() => {
                    this.insertItemsIntoView();
                    this.initPager();
                });
            });
        }

        if (durationDropdown) {
            durationDropdown.addEventListener('change', () => {
                this.fetch().then(() => {
                    this.insertItemsIntoView();
                    this.initPager();
                });
            });
        }
    }
   
    scrollToView() {
        window.scrollTo({
            top: (this.dom.container.offsetTop - this.dom.header.clientHeight),
            behavior: 'smooth'
        })
    }

    initPager() {
        this.currentPage = 1;
        this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);

        if (this.pager) {
            this.dom.container.querySelector('.pagerContainer').innerHTML = '';
            this.pager = null;
        }

        this.pager = new Pager({
            currentPage: this.currentPage,
            totalPages: this.totalPages,
        });

        this.dom.container.querySelector('.pagerContainer').appendChild(this.pager.getOrCreate());

        this.pager.getOrCreate().addEventListener('prev', e => {
            e.preventDefault();
            this.currentPage = this.currentPage - 1 || 1;
            this.setPagedListView(true);
        });

        this.pager.getOrCreate().addEventListener('next', e => {
            e.preventDefault();
            this.currentPage = Math.min(this.currentPage + 1, this.totalPages);
            this.setPagedListView(true);
        });

        this.setPagedListView(false);
    }

    initAutocomplete() {
        const form = this.dom.container.querySelector('[data-filters] form')
        const input = form.querySelector('input#searchFieldVacancies');
        const clearButton = form.querySelector('input#searchFieldVacancies + button.clearButton');
        this.autocomplete = new google.maps.places.Autocomplete(input);
        this.autocomplete.setFields([
            'address_components', 
            'geometry', 
            'name'
        ]);
        this.autocomplete.bindTo('bounds', this.map);
        this.autocomplete.addListener('place_changed', () => {
            const place = this.autocomplete.getPlace();
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                return;
            }

            if (place.geometry) {
                clearButton.classList.add('show');
            }

            this.processAutocomplete(place);
        });

        form.addEventListener('submit', e => {
            e.preventDefault();
            return false;
        });

        input.addEventListener('input').then(() => {
            if (input.value) {
                clearButton.classList.add('show');
            } else {
                clearButton.classList.remove('show');
            }
        });

        clearButton.addEventListener('click', () => {
            input.value = '';
            this.lat = null;
            this.lon = null;

            this.fetch().then(() => {
                this.insertItemsIntoView();
                this.initPager();
            });
        });
    }

    processAutocomplete(place) {
        if (place !== undefined && place.geometry !== undefined) {
            // place.geometry.location.lat()
            // place.geometry.location.lng()
            console.log({
                lat: place.geometry.location.lat(),
                lon: place.geometry.location.lng(),
            });

            this.lat = place.geometry.location.lat();
            this.lon = place.geometry.location.lng();

            this.fetch().then(() => {
                this.insertItemsIntoView();
                this.initPager();
            });
        }
    }

    setPagedListView(scrollUp = false) {
        const listContainer = this.dom.container.querySelector('.listContainer');
        const firstIndex = (this.currentPage - 1) * this.itemsPerPage;
        const lastIndex = Math.min((this.currentPage * this.itemsPerPage) - 1, this.items.length - 1);

        listContainer.querySelectorAll('.listItemWrapper').forEach((itemElement, index) => {
            if (index >= firstIndex && index <= lastIndex) {
                itemElement.classList.remove('paged');
            } else {
                itemElement.classList.add('paged');
            }
        });

        if (scrollUp) {
            this.scrollUp();
        }

        this.pager.setCurrentPage(this.currentPage);
        this.pager.getOrCreate().querySelectorAll('.currentPage').forEach(currentPage => currentPage.innerHTML = this.currentPage);
        this.pager.setButtonStatus();
    }

    changeView(listItem) {
        let mapView = this.dom.container.querySelector('section.mapView');
        let listView = this.dom.container.querySelector('section.listView');

        if (listItem.classList.contains('map')) {
            mapView.classList.add('show');
            listView.classList.remove('show');
        } else if (listItem.classList.contains('list')) {
            mapView.classList.remove('show');
            listView.classList.add('show');
        }
    }

    clearFilters() {
        // this.selectedFilters = [];
    }

    checkVal(array, value) {
        return array.some(entry => {
            if (Array.isArray(entry)) {
                return this.checkVal(entry, value);
            }

            return entry === value;
        })
    }

    changeFilters() {
        return new Promise(resolve => {
            this.selectedFilters = [];

            // Collect all checked checkboxes in their groups, add those to the selectedFilters
            this.dom.filterContainer.querySelectorAll('.filter').forEach(filterGroup => {
                var filterGroupArr = [];
                filterGroup.querySelectorAll('input[type="checkbox"]').forEach(filterCheckbox => {
                    if (filterCheckbox.checked) {
                        filterGroupArr.push(filterCheckbox.value);
                    }
                });
                if (filterGroupArr.length > 0) {
                    this.selectedFilters.push(filterGroupArr);
                }
            });

            this.updateActiveStatusOnFilter();
            this.currentPage = 1;

            this.saveToStorage();

            // Adapted from init()
            this.clearGrid();
            this.clearMarkers();
            const loadMaps = this.initMapApi();

            this.fetch().then(data => {
                this.storeApiData(data);

                // If the selected view is the map, make sure to show the items only if Maps is ready
                if (this.selectedView == 'Map') {
                    loadMaps.then(() => {
                        this.insertItemsIntoView();
                        resolve();
                    });
                } else {
                    this.insertItemsIntoView();
                    resolve();
                }
            });
        });
    }

    createMap() {
        this.map = new google.maps.Map(this.dom.mapContainer.querySelector('.map'), {
            center: { // Sort of center of NL
                lat: 52.1927064,
                lng: 5.6074137
            },
            zoom: 8,
            maxZoom: 17,
            // styles: mapStyling,
            zoomControl: true,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
        });
    }

    initMarkerClusterer() {
        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
        }

        this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
            imagePath: '/img/markerClusterer',
            // gridSize 60 is default, smaller number makes the clusters smaller (and in turn, generally increases the amount of clusters)
            gridSize: 30,
            averageCenter: true,
            styles: [
                MarkerClusterer.withDefaultStyle({
                    width: 40,
                    height: 40,
                    fontWeight: 'bold',
                    fontFamily: 'Avenir',
                    url: "/img/markercluster.svg",
                    textColor: "#ffffff",
                    textSize: 14,
                }),
            ]
        });
    }

    /**
     * Updates both the listview and map view
     */
    insertItemsIntoView() {
        this.insertMarkers();
        this.insertList();
    }

    insertList() {
        const listContainer = this.dom.container.querySelector('.listContainer');
        // this.pager.currentPage = 1;
        listContainer.innerHTML = ``;
        this.items.forEach(item => {
            let listItem = new ListItem(item);

            listContainer.appendChild(listItem.getOrCreate());
        });
    }

    insertMarkers() {
        this.clearMarkers();

        const bounds = new window.google.maps.LatLngBounds();
        this.items.filter(item => item.Lat && item.Lon).forEach(item => {
            let marker = new window.google.maps.Marker({
                map: this.map,
                position: {
                    lat: parseFloat(item.Lat),
                    lng: parseFloat(item.Lon),
                },
                icon: {
                    url: '/img/icon_vacancy_marker.svg',
                    size: new google.maps.Size(36, 44),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 42),
                },
                title: item.Title,
            });
            this.markers.push(marker);

            bounds.extend(marker.position);

            marker.addListener('click', () => {
                this.selectMarker(marker, item);
            });
        });

        this.initMarkerClusterer();

        // Center the map around the markers
        if (this.markers.length) {
            this.map.fitBounds(bounds);
        } else {
            let latlng = {
                lat: 52.00000,
                lng: 4.4978113
            }
            this.map.setCenter(latlng);
            this.map.setZoom(10);
        };


        // window.app.registerResizeEvent(() => {
        //     if (window.innerWidth >= app.breakpoints.md.size) {
        //         if (this.markers.length) {
        //             this.map.fitBounds(bounds);
        //         } else {
        //             let latlng = {
        //                 lat: 52.00000,
        //                 lng: 4.4978113
        //             }
        //             this.map.setCenter(latlng);
        //             this.map.setZoom(10);
        //         };
        //     }
        // });
    }

    clearMarkers() {
        // this.closeMapPopup();
        this.markers.forEach(marker => {
            marker.setMap(null);
        });
        this.markers = [];
    }

    selectMarker(marker, item) {
        this.markers.forEach(marker => {
            marker.setIcon({
                url: '/img/icon_vacancy_marker.svg',
                size: new google.maps.Size(36, 44),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(17, 42),
            })
        });

        marker.setIcon({
            url: '/img/icon_vacancy_marker_inverted.svg',
            size: new google.maps.Size(36, 44),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(17, 42),
        });

        this.map.panTo(marker.getPosition());
        this.map.panBy(0, -100);

        if (this.infoWindow) {
            this.infoWindow.close();
        }

        this.infoWindow = new google.maps.InfoWindow({
            content: `<div class="mapPopup">
                <div class="content">
                    ${item.City ? `<span class="city">${item.City}</span>` : ``}
                    ${item.Title ? `<span class="title">${item.Title}</span>` : ``}
                    ${item.Duration ? `<span class="duration">${item.Duration}</span>` : ``}
                    ${item.Url ? `<a href="${item.Url}" title="Bekijk de vacature ${item.Title}">
                        <span>Bekijk vacature</span>
                    </a>` : ``}
                </div>
            </div>`,
        });
        this.infoWindow.open(this.map, marker);
    }

    /**
     * Fetches info from the API with the needed parameters
     * @returns {Promise} Promise containing Object with selected items
     */
    fetch() {
        let typeDropdown = this.dom.container.querySelector('select[name="type"]');
        let durationDropdown = this.dom.container.querySelector('select[name="duration"]');

        const data = {};

        if (typeDropdown && typeDropdown.value != '') {
            data.Type = typeDropdown.value;
        }

        if (durationDropdown && durationDropdown.value != '') {
            data.Duration = durationDropdown.value;
        }

        if (this.lat && this.lon) {
            data.fromlat = this.lat;
            data.fromLong = this.lon;
            data.distance = 5000;
        }

        return this.api.getOverview(data).then(result => {
            // Save this to the object's cache
            this.items = result;
        });
    }

    scrollUp() {
        const neededScroll = window.app.elementCoords(this.dom.container).top - 200;

        if (neededScroll < (window.pageYOffset || docEl.scrollTop)) {
            window.scroll({
                top: neededScroll,
                behavior: 'smooth',
            });
        }
    }

    // popupSizeCheck() {
    //     let button = this.dom.viewButtonsContainer.querySelector('button');
    //     let popups = this.dom.filterContainer.querySelectorAll('.filter .popup');
    //     let locationPopup = this.dom.container.querySelector('.filtersColumn .filter.location .popup');

    //     if (button.classList.contains('d-none')) {
    //         popups.forEach(popup => {
    //             popup.classList.add('small');
    //         });

    //         locationPopup.classList.add('small');
    //     } 
    // }
}